
import { onCLS, onINP, onLCP, type Metric } from 'web-vitals';
import { errorReportsApi } from '@/shared/api';
import { telemetryUrl } from '@/shared/api/report-url';

const reportedThisSession = new Set<string>();

function report(metric: Metric, formatted: string): void {
  if (metric.rating !== 'poor' || reportedThisSession.has(metric.name)) return;
  reportedThisSession.add(metric.name);
  void errorReportsApi
    .send({
      kind: 'metric',
      message: `Web Vitals: ${metric.name} ${formatted} (poor)`,
      url: telemetryUrl(window.location.href),
      userAgent: navigator.userAgent,
    })
    .catch(() => undefined);
}

export function initWebVitals(): void {
  onLCP((m) => report(m, `${Math.round(m.value)}ms`));
  onINP((m) => report(m, `${Math.round(m.value)}ms`));
  onCLS((m) => report(m, m.value.toFixed(3)));
}
